import { Skeleton } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

const LoadingSkeleton = () => {
  return (
    <>
        <Box
            display="flex"
            justifyContent="space-between"
            py={2}
            px={3}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
        >
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="20%" />
        </Box>
        <Box
            display="flex"
            justifyContent="space-between"
            py={2}
            px={3}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
        >
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="20%" />
        </Box>
        <Box
            display="flex"
            justifyContent="space-between"
            py={2}
            px={3}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
        >
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="20%" />
        </Box>
        <Box
            display="flex"
            justifyContent="space-between"
            py={2}
            px={3}
            sx={{ borderBottom: 1, borderColor: 'gray-line.main' }}
        >
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="20%" />
        </Box>
    </>
  )
}

export default LoadingSkeleton